const LOCAL_STORAGE = {
  WHATS_NEW_DISMISSED_VERSION: 'whats_new_dismissed_version',
} as const;

export { LOCAL_STORAGE, LOCAL_STORAGE as LS };
